import api from './api';
import { Dentist, Availability } from '../types';

export const dentistService = {
  async getAll(): Promise<Dentist[]> {
    const response = await api.get('/dentists');
    return response.data;
  },

  async getById(id: string): Promise<Dentist> {
    const response = await api.get(`/dentists/${id}`);
    return response.data;
  },

  async create(data: Partial<Dentist>): Promise<Dentist> {
    const response = await api.post('/dentists', data);
    return response.data;
  },

  async update(id: string, data: Partial<Dentist>): Promise<Dentist> {
    const response = await api.patch(`/dentists/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/dentists/${id}`);
  },

  async getAvailability(id: string): Promise<Availability[]> {
    const response = await api.get(`/dentists/${id}/availability`);
    return response.data;
  },

  async getAppointments(id: string, startDate?: string, endDate?: string) {
    const response = await api.get(`/dentists/${id}/appointments`, {
      params: { startDate, endDate },
    });
    return response.data;
  },
};
